










































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import SparkIcon from '@/components/icons/SparkIcon.vue';

@Component({
  components: {
    SparkIcon,
  },
})
export default class GlobalHeader extends Vue {
  @Prop(String) title!: string;
  @Prop(Boolean) loggedIn!: boolean;
  @Prop(Boolean) showBackToHome!: boolean;
  @Prop(Boolean) showSparkLink!: boolean;

  handleLogout() {
    this.$emit('logout');
  }

  handleSparkLink() {
    this.$emit('click:spark');
  }
  handleBackClick() {
    this.$emit('click:back');
  }
  handleLogoClick() {
    this.$emit('click:logo');
  }
}
